const styles = {
  mainContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  inputSearch: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      background: 'none!important',
      borderStyle: 'solid',
      borderWidth: 1,
      borderColor: 'divider',
      padding: 0,
      boxShadow: 'none!important',
    },
    '& .MuiOutlinedInput-input ': {
      padding: '0 5px',
    },
    '& .MuiOutlinedInput-input::placeholder ': {
      padding: '0 5px',
      fontWeight: '600',
      fontSize: '14px',
      lineHeight: '21px',
      color: 'common.secondaryDark',
      opacity: '1',
    },
  },
  searchIcon: { '&.MuiSvgIcon-root ': { color: 'common.black' } },
}

export default styles
